var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgD1Oven(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 3v70h58V3H9zm54 66H13V21h50v48zm0-52H13V7h50v10zm-4 8H17v40h42V25zM21.25 36.09c3.32.56 7 2.08 8.67 4.57a16.519 16.519 0 0124.33.27 16.53 16.53 0 01-24.37.23 15.77 15.77 0 01-8.63 4.61l2.16-4.84-2.16-4.84zM50.75 55h-25a4 4 0 01-4-4h33a4 4 0 01-4 4zM59 14h-4v-4h4v4zm-7 0h-4v-4h4v4zm-6.68 26.46a1.68 1.68 0 113.36 0 1.68 1.68 0 01-3.36 0zM39 14H17v-4h22v4z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/D1_Oven.17de4649.svg";
export { SvgD1Oven as ReactComponent };